@let vm = vm$();

<div class="w-100 h-100 flex-col gap-16">
  @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
    <div class="flex-col gap-16">
      <ui-search
        style="width: 320px"
        [placeholder]="'UNIFORM.SEARCH' | translate"
        [searchQuery]="vm.query"
        (searchQueryChange)="query.set($event)">
      </ui-search>
    </div>
  }

  @switch (vm.viewState) {
    @case ('LOADING') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-preloader></ui-preloader>
      </div>
    }
    @case ('INITIAL_EMPTY') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data
          [imgSrc]="noData.imgSrc"
          [title]="noData.title | translate"
          [createButtonText]="noData.createButtonText | translate"
          (onCreate)="navigateToUnsaved.emit()">
        </ui-no-data>
      </div>
    }
    @case ('NO_RESULTS') {
      <div class="h-100 w-100 flex-col center-center">
        <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
      </div>
    }
    @case ('HAS_DATA') {
      <div class="uniforms-grid">
        @for (uniform of vm.filteredUniforms; track uniform.uniformId) {
          <ui-uniform-card
            [uniform]="uniform"
            [name]="uniform.name"
            [bestImage]="uniform.bestImage"
            [isSaved]="true"
            [allowEdit]="true"
            (edit)="editUniform(uniform)"
            (remove)="removeUniform(uniform)">
          </ui-uniform-card>
        }
      </div>
    }
  }
</div>
